import React from 'react'
import classNames from 'classnames/bind'
import { USER_ROLES } from 'constants/user'
import AccessWrapper from 'apps/AccessWrapper'
import Button from 'elements/Button'
import { toCurrency } from 'utils/price'
import * as styles from './../PlanItem.scss'
import Tooltip from 'apps/Tooltip'

const cx = classNames.bind(styles)

const MultiPlanItem = ({ plan, plan2, t, onSelectSubscriptionPlan, onChangeCheckBox, isAccessibleToUser, isSelectable, isSelectable2 }) => (

  <div className={cx(styles.root)}>
    <div className={styles.image}>
      <img src={plan.visible ? plan.imageUri : plan2.imageUri} alt={plan.visible ? plan.name : plan2.name} />
    </div>
    <div className={styles.content}>
      <div>
        <div className={styles.name}>{plan.visible ? plan.name : plan2.name}</div>
        <h2 className={cx(styles.price, { withFee: !!plan.activationFee })}>

          {plan.visible && t('price', { price: toCurrency(plan.price) })}
          {plan2.visible && t('price', { price: toCurrency(plan2.price) })}

          {!plan.activationFee && plan.visible && (
            <div className={styles.fee}>
              /mo + no activation fee
            </div>
          )}

          {!!plan2.activationFee && plan2.visible && (
            <div className={styles.fee}>
              /mo {t('activationFee', { activationFee: toCurrency(plan2.activationFee) })}
            </div>
          )}

        </h2>
        <div className={styles.planFeaturesTitle}>
          {t('planFeaturesTitle')}
        </div>
        <ul className={styles.options}>
          {plan.visible && plan.description && plan.description.split('|').map((item, index) => (
            <li key={index} className={styles.option}>{item}</li>
          ))}
          {plan2.visible && plan2.description && plan2.description.split('|').map((item, index) => (
            <li key={index} className={styles.option}>{item}</li>
          ))}
        </ul>
      </div>
      <div className={styles.checkboxWrapper}>
        <input className={styles.checkbox} checked={plan2.visible}
        onChange={(e) => onChangeCheckBox(plan.weight, e)} type='checkbox'/>
        <div>
            <span><b>Save $10 each month</b> by paying an activation fee
              <Tooltip
                id={`activation-tooltip-${plan.visible ? plan.id : plan2.id}`}
                title={t('payLessTooltipHeader')}
                content={t('payLessTooltipBody')}
                position='bottom'
              />
            </span>
        </div>
      </div>
      <AccessWrapper {...(isAccessibleToUser ?
          { off : [USER_ROLES.subscriptionUser] }
        : { off : [] })}>
        <div className={styles.button}>

        {plan.visible && (
          <Button
          onClick={() => onSelectSubscriptionPlan(plan.id)}
          fluid
          >
          {isSelectable ? t('selectPlanButton') : t('notifyPlanButton')}
          </Button>
        )}

        {plan2.visible && (
          <Button
          onClick={() => onSelectSubscriptionPlan(plan2.id)}
          fluid
          >
          {isSelectable2 ? t('selectPlanButton') : t('notifyPlanButton')}
          </Button>
        )}

        </div>
      </AccessWrapper>
    </div>
  </div>
)

export default MultiPlanItem
